import { all, fork } from "redux-saga/effects";

import { Authnz } from "capitalrx-components";

import searchForMemberWatcher from "./appSagas/members/search";
import searchForClaimWatcher from "./appSagas/claims/search";
import searchForPlanBenefitWatcher from "./appSagas/planBenefits/search";
import getMemberWatcher from "./appSagas/members/get";
import searchForPlanWatcher from "./appSagas/plans/search";
import getPlanWatcher from "./appSagas/plans/get";
import getGroupWatcher from "./appSagas/groups/get";
import getPlanAccountGetWatcher from "./appSagas/planAccounts/get";
import searchForPharmacyWatcher from "./appSagas/pharmacy/search";
import listPricingLevelsWatcher from "./appSagas/pricingLevels/list";
import createPricingLevelWatcher from "./appSagas/pricingLevels/create";
import getPricingLevelWatcher from "./appSagas/pricingLevels/get";
import updatePricingLevelWatcher from "./appSagas/pricingLevels/update";
import getPharmacyWatcher from "./appSagas/pharmacy/get";
import getBatchTestClaimWatcher from "./appSagas/transmissions/batchTest/get";
import downloadBatchTestClaimWatcher from "./appSagas/transmissions/batchTest/download";
import getBatchTestClaimListWatcher from "./appSagas/transmissions/batchTest/list";
import transmissionTestWatcher from "./appSagas/transmissions/testTransmission";
import transmissionTestAsBatchWatcher from "./appSagas/transmissions/testAsBatchTransmission";
import uploadTestClaimBatchWatcher from "./appSagas/transmissions/batchTest/upload";
import getBatchManualClaimWatcher from "./appSagas/transmissions/batchManual/get";
import downloadBatchManualClaimWatcher from "./appSagas/transmissions/batchManual/download";
import getBatchManualClaimListWatcher from "./appSagas/transmissions/batchManual/list";
import transmissionManualWatcher from "./appSagas/transmissions/manualTransmission";
import uploadManualClaimBatchWatcher from "./appSagas/transmissions/batchManual/upload";
import drugSearchWatcher from "./appSagas/drug/search";
import drugSelectedSearchWatcher from "./appSagas/drug/searchForSelected";
import getProductListWatcher from "./appSagas/productLists/list";
import migrateUserWatcher from "./appSagas/migrate/migrate";

export default function* rootSagas(): Generator {
  yield all([
    fork(Authnz.authnzWatcher),
    fork(searchForMemberWatcher),
    fork(searchForClaimWatcher),
    fork(searchForPlanBenefitWatcher),
    fork(getMemberWatcher),
    fork(searchForPlanWatcher),
    fork(getPlanWatcher),
    fork(getPlanAccountGetWatcher),
    fork(getGroupWatcher),
    fork(searchForPharmacyWatcher),
    fork(getPharmacyWatcher),
    fork(getBatchTestClaimWatcher),
    fork(downloadBatchTestClaimWatcher),
    fork(getBatchTestClaimListWatcher),
    fork(getBatchManualClaimWatcher),
    fork(downloadBatchManualClaimWatcher),
    fork(getBatchManualClaimListWatcher),
    fork(transmissionTestWatcher),
    fork(transmissionTestAsBatchWatcher),
    fork(transmissionManualWatcher),
    fork(uploadTestClaimBatchWatcher),
    fork(uploadManualClaimBatchWatcher),
    fork(drugSearchWatcher),
    fork(drugSelectedSearchWatcher),
    fork(getProductListWatcher),
    fork(migrateUserWatcher),
    fork(listPricingLevelsWatcher),
    fork(createPricingLevelWatcher),
    fork(getPricingLevelWatcher),
    fork(updatePricingLevelWatcher),
  ]);
}
